import React from 'react';
import { showPricePerUnit } from '../../../Utils/CategoryPageUtils';
import { CardPrice } from './CategoryNewStyled';
import ProductPriceAB from '../../../Utils/ProductPriceAB';

function PriceSection(props) {
  const { data, rupeeSymbol, userType, isCategory } = props;
  const strikePrice =
    data?.strikePrice || data?.strike_price || data?.strikeprice;
  let price = data?.actual_web_price?.toString() || data?.price;
  const priceWithoutSymbol = price?.toString()?.includes('₹')
    ? JSON.parse(price.replace('₹', ''))
    : price;

  return (
    <>
      <CardPrice perUnit>
        {isCategory ? (
          <ProductPriceAB
            priceData={data}
            classString="mainPrice"
            classStringStrike="strikePriceCat"
            classStringDisc="discountCat"
            noGap={true}
            noPadding={true}
          />
        ) : (
          <div className="mainPriceContainer">
            <span className="mainPrice">
              <sup>₹</sup>
              {priceWithoutSymbol}
            </span>
            {showPricePerUnit(userType, data?.pricePerUnit) && (
              <span className="pricePerCount">{data?.pricePerUnit}</span>
            )}
            <div>
              <span className="strikePrice">
                {rupeeSymbol ? `₹${strikePrice}` : strikePrice}
              </span>
              <span className="discount">{data?.discount}</span>
            </div>
          </div>
        )}
      </CardPrice>
      {/* )} */}
    </>
  );
}

export default PriceSection;
